import React from 'react'
import "./AboutlandingPage.css"

function C2wAboutLanding() {
  return (
    <div className='C2wAboutLanding'>
      <div className='C2wAboutLanding_container'>
        <div className='C2wAboutLanding_heading_container'>
          <h1>Shashi Sir</h1>
          <p>MASTER</p>
        </div>
        <div className='C2wAboutLanding_imageHolder'>
          <img src='/assets/images/aboutus/sir.png' alt='/' />
        </div>
        <div className='C2wAboutLandingLogo_holder'>
          <div className='C2wAboutLandingLogo_holder_container'>
          <img className='course_image cLanguage' src='/assets/images/aboutus/ppa.png' alt='course_cLanguage' />
          <img className='course_image python' src='/assets/images/aboutus/python.png' alt='course_python' />
          <img className='course_image java' src='/assets/images/aboutus/java.png' alt='course_java' />
          <img className='course_image backend' src='/assets/images/aboutus/backend.png' alt='course_backend' />
          <img className='course_image os' src='/assets/images/aboutus/os.png' alt='course_os' />
          <img className='course_image machineLearng' src='/assets/images/aboutus/machineLearng.png' alt='course_machineLearning' />
          <img className='course_image iot' src='/assets/images/aboutus/iot.png' alt='course_iot' />
          <img className='course_image flutter' src='/assets/images/aboutus/flutter.png' alt='course_flutter' />
          <img className='course_image mysql' src='/assets/images/aboutus/MySQL.png' alt='course_mysql' />
          <img className='course_image web' src='/assets/images/aboutus/Web.png' alt='course_web' />
          <img className='course_image c++' src='/assets/images/aboutus/C++.png' alt='course_c++' />
          <img className='course_image dsa' src='/assets/images/aboutus/DSA.png' alt='course_dsa' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default C2wAboutLanding